import { createIcon as c } from "../createIcon.js";
const e = {
  name: "CircleXmarkIcon",
  height: 512,
  width: 512,
  svgPath: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z",
  yOffset: 0,
  xOffset: 0
}, o = c(e);
export {
  o as CircleXmarkIcon,
  e as CircleXmarkIconConfig,
  o as default
};
